// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Lo-z","outfitFeedbackSection":"Mo-z"};